import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center w-full mt-2" }
const _hoisted_2 = { class: "flex items-center space-x-4 overflow-hidden" }
const _hoisted_3 = { class: "flex flex-col -space-y-1 overflow-hidden" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "flex items-center space-x-1 overflow-hidden" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"14px !important"},
  class: "material-icons-outlined icon-light"
}, " email ", -1)
const _hoisted_9 = { class: "text-sm text-muted" }
const _hoisted_10 = { class: "flex items-center space-x-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"18px !important"},
  class: "material-icons-outlined"
}, "launch", -1)
const _hoisted_13 = {
  key: 2,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { "margin-less": true }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Avatar, {
            size: 'lg',
            user: _ctx.user
          }, null, 8, ["user"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: "overflow-hidden overflow-ellipsis",
              title: _ctx.user.full_name
            }, _toDisplayString(_ctx.user.full_name), 9, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: "overflow-hidden text-sm text-muted overflow-ellipsis",
                title: _ctx.user.email
              }, _toDisplayString(_ctx.user.email), 9, _hoisted_6),
              _createElementVNode("a", {
                style: {"margin-bottom":"-4.85px"},
                href: 'mailto:' + _ctx.user.email
              }, [
                _createVNode(_component_Btn, {
                  size: 'xs',
                  variant: 'icon',
                  outline: true
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ], 8, _hoisted_7)
            ])
          ])
        ]),
        _createVNode(_component_Btn, {
          class: "ml-auto",
          outline: true,
          variant: 'icon',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["transition-transform duration-200 ease-out transform material-icons-outlined", { 'rotate-180': _ctx.expanded }])
            }, " expand_more ", 2)
          ]),
          _: 1
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["duration-200 ease-in-out transition-max-height", {
					'max-h-0 overflow-hidden': !_ctx.expanded,
					'max-h-96 overflow-y-auto': _ctx.expanded,
				}])
      }, [
        (_ctx.fetching)
          ? (_openBlock(), _createBlock(_component_SkeletonCard, {
              key: 0,
              "border-less": true,
              class: "-ml-4"
            }))
          : (_openBlock(), _createBlock(_component_Timeline, {
              key: 1,
              class: "mt-4",
              steps: _ctx.processedHistory
            }, {
              default: _withCtx(({ timestamp, eventType, data }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Timestamp, { value: timestamp }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("course_insights.user_history_event_descriptions." + eventType)) + " ", 1),
                    (eventType === _ctx.EventType.EXAM)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(data.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_router_link, {
                    to: {
								name: 'ExamParticipationFull',
								params: { examId: data.examId, participationId: data.id },
							},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, {
                        outline: true,
                        variant: 'icon'
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 1
            }, 8, ["steps"])),
        (_ctx.processedHistory.length === 0 && !_ctx.fetching)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("course_insights.no_user_activity")), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}